<template>
    <App title="Cluster Management">
        <Block>
            <template #header>
                <h3 class="block-title">Clusters</h3>
            </template>
            <Datatable :options="options" />
        </Block>
    </App>
</template>

<script lang="ts">
import Block from '@/vue/components/Block.vue'
import Datatable from '@/vue/components/Datatable.vue'
import App from '@/vue/templates/App.vue'
import { CellRender, Column } from '@/vue/utils/Datatable'
import { Component, toNative, Vue } from 'vue-facing-decorator'

@Component({
    components: {
        App,
        Block,
        Datatable,
    },
})
class Group extends Vue {
    get buttons() {
        let buttons: any[] = []
        buttons.push('refresh')
        buttons.push({
            extend: 'create',
            attr: {
                href: this.route('cluster.page.create'),
            },
        })
        buttons.push('trashed')

        return buttons
    }

    get columns() {
        let columns: any[] = []

        columns.push({
            data: 'title',
            title: 'Cluster Name',
        })

        columns.push({
            data: 'zone.title',
            title: 'Zone Location',
            orderable: true,
            name: 'zone',

        })

        columns.push({
            data: 'manager.fullname',
            title: 'Manager',
        })


        columns.push({
            data: 'created_at',
            title: 'Registered',
            render: CellRender.date(),
            orderable: true,
            name: 'created_at',
        })

        columns.push(Column.actions(this.$gate))

        return columns
    }

    get options() {
        return {
            ajax: {
                url: this.route('cluster.ajax.table'),
                method: 'POST',
            },
            buttons: this.buttons,
            columns: this.columns,
        }
    }
}
export default toNative(Group)
</script>
